// Story 1.21 — pending-application status card. Renders when the
// user's most recent application is still under review.

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@greenhold/components";

import type { CreatorApplicationStatus } from "./useCreatorApplicationStatus";
import { IdentityVerifyField } from "./IdentityVerifyField";

interface Props {
  application: CreatorApplicationStatus;
}

export function PendingApplicationCard({ application }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Your application is being reviewed</CardTitle>
        <CardDescription>
          We aim to respond within 48 hours of submission. You'll get an email
          the moment a decision is made.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {application.image_signed_url && (
          <div className="flex items-center gap-4">
            <img
              src={application.image_signed_url}
              alt="Your creator photo"
              className="w-24 h-24 rounded-full object-cover border-2 border-brand-gold-500"
            />
            <div>
              <p className="font-heading font-bold text-xl">
                {application.display_name}
              </p>
              <p className="italic opacity-90">{application.hello_text}</p>
            </div>
          </div>
        )}
        <dl className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
          <dt className="opacity-70">Region</dt>
          <dd>{application.region}</dd>
          <dt className="opacity-70">Language</dt>
          <dd>{application.language}</dd>
          <dt className="opacity-70">Submitted</dt>
          <dd>{new Date(application.submitted_at).toLocaleString()}</dd>
        </dl>

        {/* Verifying (or re-verifying) a channel while under review still
            helps — the reviewer sees the proof before deciding. Nothing to
            save here, so no onBeforeConnect. */}
        <IdentityVerifyField />
      </CardContent>
    </Card>
  );
}
